/**
 * Classify tenant-scoped employment gaps for the applicant journey.
 * Backend worker_state is authoritative; legacy status is only a fallback.
 * Submission is NOT verification. Waiting-on-admin must not reappear as an
 * applicant task, and verified records must not reopen editable controls.
 */
export function classifyEmploymentGapForApplicant(gap = {}) {
  const workerState = String(gap.worker_state || '').toLowerCase();
  const status = String(gap.status || gap.verification_status || '').toLowerCase();

  // Explicit worker action after a reopened review overrides a stale raw
  // "verified" legacy status; do not hide a genuine correction request.
  if (workerState === 'action_required' || workerState === 'update_needed') {
    return 'actionable';
  }
  if (workerState === 'awaiting_admin_review') {
    return 'awaiting_review';
  }
  if (workerState === 'reviewed' || status === 'verified' || status === 'approved') {
    return 'verified';
  }
  if (['reopened', 'rejected', 'needs_more_info', 'update_needed', 'pending', 'unexplained', 'action_required'].includes(status)) {
    return 'actionable';
  }
  if (['explained', 'submitted', 'awaiting_admin_review', 'pending_review'].includes(status)) {
    return 'awaiting_review';
  }
  // Unknown legacy states require clarification, not a false "verified" badge.
  return 'actionable';
}

export function partitionEmploymentGaps(gaps = []) {
  const result = { actionable: [], awaitingReview: [], verified: [] };
  for (const gap of Array.isArray(gaps) ? gaps : []) {
    const state = classifyEmploymentGapForApplicant(gap);
    if (state === 'verified') result.verified.push(gap);
    else if (state === 'awaiting_review') result.awaitingReview.push(gap);
    else result.actionable.push(gap);
  }
  return result;
}
